import { useContext, useState } from 'react';
import MenuItemMobile from './MenuItemMobile';
import { UserContext } from '@context/createContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ToastError from '../modules/toast/ToastError';
import { deleteAllCookies } from '@helper/functions';
import { sidebarMobile } from '@/constants/sidebarData';
import ConfirmationModal from '@core/ConfirmationModal';

// لیست دامنه‌های مجاز برای دسترسی به فایلینگ پرو
const ALLOWED_SUBDOMAINS = [
  'amlakeskan.dubz.ir',
  'ideal.dubz.ir',
  'mina.dubz.ir',
  'kimia-gostar.dubz.ir',
  'madar.dubz.ir',
  'sahel.dubz.ir',
  'benolmelal.dubz.ir',
  'khaneshoma.dubz.ir',
  'diyar.dubz.ir',
  'maskangostar.dubz.ir',
  'dubzhome.dubz.ir',
];

export default function SidebarMobile() {
  const {
    user: { Name, UserType, RealEstateId },
  } = useContext(UserContext);

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="w-full lg:hidden p-4 fixed bottom-0 left-0 right-0 z-20">
        <div className="grid grid-cols-5 max-lg:gap-16 max-sm:gap-0 h-[72px] shadow-2xl w-full bg-white dark:bg-blackFont-900 px-4 py-2 border-[1px] border-text-normal/20 dark:border-blackFont-700 rounded-full">
          {UserType == 'Agent' &&
            sidebarMobile
              .filter((item) => item.agent === true)
              .map((i) => <MenuItemMobile key={i.id} {...i} open={open} setOpen={setOpen} realState={RealEstateId} />)}

          {UserType == 'RealEstate' &&
            sidebarMobile
              .filter((item) => item.rsOwner === true)
              .map((i) => <MenuItemMobile key={i.id} {...i} open={open} setOpen={setOpen} realState={RealEstateId} />)}
        </div>
      </div>
      {open && <MenuFilterMobile setOpen={setOpen} />}
    </>
  );
}

function MenuFilterMobile({ setOpen }) {
  const {
    realEstate,
    clearUser,
    user: { Name, UserType, RealEstateId },
  } = useContext(UserContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [openModal, setOpenModal] = useState(false);
  const isEskanSubdomain = ALLOWED_SUBDOMAINS.includes((realEstate?.subdomain || '').toLowerCase());

  const logoutHandler = async () => {
    await deleteAllCookies();
    await clearUser();
    navigate('/login', { replace: true });
  };

  const navigateSubdomain = () => {
    // استفاده از domain اگر وجود داشته باشد، در غیر این صورت از subdomain استفاده می‌کنیم
    const baseUrl = realEstate?.domain && realEstate.domain.trim() ? realEstate.domain : realEstate?.subdomain;

    if (UserType == 'Agent') {
      if (!baseUrl || !realEstate.color) {
        ToastError({ content: 'اطلاعات املاک شما کامل نیست' });
      } else {
        window.open(`https://${baseUrl}/${Name.username}`, '_blank', 'noopener,noreferrer');
      }
    } else {
      if (!baseUrl) {
        ToastError({ content: 'برای سایت املاک هنوز آدرسی ثبت نشده' });
        navigate('settings#SiteSubdomain');
      } else if (!realEstate.color) {
        ToastError({ content: 'برای سایت املاک هنوز رنگ سازمانی ثبت نشده' });
        navigate('settings#OrganizationalColor');
      } else {
        window.open(`https://${baseUrl}`, '_blank', 'noopener,noreferrer');
      }
    }
  };
  console.log(realEstate);
  return (
    <>
      <div
        className={`fixed inset-0 z-30 flex flex-col bg-white dark:bg-blackFont-900 h-screen w-screen p-5 modalFilter transition-all overflow-hidden`}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
      >
        <div className="w-full flex fle-row items-center justify-between border-b-[1px] border-b-light-grey dark:border-blackFont-700 pb-4">
          <p className="font-medium text-sm text-text-hard dark:text-white">منو</p>
          <p
            onClick={() => {
              setOpen(false);
            }}
            className="text-text-normal dark:text-white text-sm"
          >
            بستن
          </p>
        </div>
        <div className="flex flex-col justify-between h-full mt-5 w-full">
          <div className="flex flex-col gap-3">
            {/* <div
              className={`${
                location.pathname.includes('/reminders')
                  ? 'text-primary border-primary'
                  : 'text-text-normal border-light-grey'
              } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
            >
              <div className="flex flex-row items-center p-4 relative">
                <Link
                  onClick={() => setOpen(false)}
                  to={`/reminders`}
                  className="absolute w-full h-full right-0 top-0 rounded-md"
                />
                <div className="flex flex-row items-center gap-2 w-full">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.24"
                      d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V9V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V9V7.5Z"
                      fill="currentColor"
                    />
                    <path
                      d="M17 3.5H7C4.79086 3.5 3 5.29086 3 7.5V9H21V7.5C21 5.29086 19.2091 3.5 17 3.5Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.32"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 1.25C8.41421 1.25 8.75 1.58579 8.75 2V5C8.75 5.41421 8.41421 5.75 8 5.75C7.58579 5.75 7.25 5.41421 7.25 5V2C7.25 1.58579 7.58579 1.25 8 1.25ZM16 1.25C16.4142 1.25 16.75 1.58579 16.75 2V5C16.75 5.41421 16.4142 5.75 16 5.75C15.5858 5.75 15.25 5.41421 15.25 5V2C15.25 1.58579 15.5858 1.25 16 1.25Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75H12.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
                      fill="currentColor"
                    />
                  </svg>
                  <p className="text-base">یادآورها</p>
                </div>
              </div>
            </div> */}
            {RealEstateId ? (
              <button
                className={`${
                  location.pathname.includes('/customers')
                    ? 'text-primary border-primary'
                    : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
                } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/customers`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M9.92154 2.57125C11.2077 1.80958 12.7923 1.80958 14.0785 2.57125L18.9215 5.43932C20.2077 6.20099 21 7.6086 21 9.13192V14.8681C21 16.3914 20.2077 17.799 18.9215 18.5607L14.0785 21.4288C12.7923 22.1904 11.2077 22.1904 9.92154 21.4288L5.07846 18.5607C3.7923 17.799 3 16.3914 3 14.8681V9.13192C3 7.6086 3.7923 6.20099 5.07846 5.43932L9.92154 2.57125Z"
                        fill="currentColor"
                      />
                      <path
                        d="M9.92155 21.4286C11.2077 22.1903 12.7923 22.1903 14.0785 21.4286L18.301 18.928C17.0431 16.698 14.6924 15.1978 12 15.1978C9.30764 15.1978 6.95688 16.698 5.69897 18.928L9.92155 21.4286Z"
                        fill="currentColor"
                      />
                      <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 9 13)" fill="currentColor" />
                    </svg>
                    <p className="text-base">لیست مشتریان</p>
                  </div>
                </div>
              </button>
            ) : (
              <button
                disabled={true}
                className={`${
                  location.pathname.includes('/customers')
                    ? 'text-primary border-primary'
                    : 'text-text-normal border-light-grey'
                } flex flex-col disabled:opacity-50 rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M9.92154 2.57125C11.2077 1.80958 12.7923 1.80958 14.0785 2.57125L18.9215 5.43932C20.2077 6.20099 21 7.6086 21 9.13192V14.8681C21 16.3914 20.2077 17.799 18.9215 18.5607L14.0785 21.4288C12.7923 22.1904 11.2077 22.1904 9.92154 21.4288L5.07846 18.5607C3.7923 17.799 3 16.3914 3 14.8681V9.13192C3 7.6086 3.7923 6.20099 5.07846 5.43932L9.92154 2.57125Z"
                        fill="currentColor"
                      />
                      <path
                        d="M9.92155 21.4286C11.2077 22.1903 12.7923 22.1903 14.0785 21.4286L18.301 18.928C17.0431 16.698 14.6924 15.1978 12 15.1978C9.30764 15.1978 6.95688 16.698 5.69897 18.928L9.92155 21.4286Z"
                        fill="currentColor"
                      />
                      <circle cx="3" cy="3" r="3" transform="matrix(1 0 0 -1 9 13)" fill="currentColor" />
                    </svg>
                    <p className="text-base">لیست مشتریان</p>
                  </div>
                </div>
              </button>
            )}
            {UserType !== 'agent' && (
              <div
                className={`${
                  location.pathname.includes('/subscription')
                    ? 'text-primary border-primary'
                    : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
                } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/subscription`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M16.7702 18.98H7.23024C6.81024 18.98 6.43024 18.71 6.29024 18.32L2.13024 6.66998C1.80024 5.73998 2.86024 4.94998 3.65024 5.51998L7.65024 8.37998C8.18024 8.75998 8.94024 8.52998 9.17024 7.91998L11.0602 2.87998C11.3802 2.00998 12.6102 2.00998 12.9302 2.87998L14.8202 7.91998C15.0502 8.53998 15.8002 8.75998 16.3402 8.37998L20.3402 5.51998C21.1402 4.94998 22.1902 5.74998 21.8602 6.66998L17.7002 18.32C17.5702 18.71 17.1902 18.98 16.7702 18.98Z"
                        fill="currentColor"
                      />
                      <path
                        opacity="0.8"
                        d="M17 22H7C6.59 22 6.25 21.66 6.25 21.25C6.25 20.84 6.59 20.5 7 20.5H17C17.41 20.5 17.75 20.84 17.75 21.25C17.75 21.66 17.41 22 17 22Z"
                        fill="currentColor"
                      />
                      <path
                        opacity="0.8"
                        d="M14.5 14.75H9.5C9.09 14.75 8.75 14.41 8.75 14C8.75 13.59 9.09 13.25 9.5 13.25H14.5C14.91 13.25 15.25 13.59 15.25 14C15.25 14.41 14.91 14.75 14.5 14.75Z"
                        fill="currentColor"
                      />
                    </svg>
                    <p className="text-base">مدیریت اشتراک</p>
                  </div>
                </div>
              </div>
            )}
            {UserType != 'agent' && (
              <div
                className={`${
                  location.pathname.includes('/agents/invations')
                    ? 'text-primary border-primary'
                    : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
                } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/agents/invations`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 12V18"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        opacity="0.8"
                        d="M20 8V7C20 5.34315 18.6569 4 17 4H14.1975C13.5294 4 12.8805 3.77702 12.3535 3.3664L11.4131 2.6336C10.8862 2.22298 10.2372 2 9.56917 2H7C5.34315 2 4 3.34315 4 5V8H20Z"
                        fill="currentColor"
                      />
                      <path
                        opacity="0.24"
                        d="M20.5261 8H3.47403C2.20074 8 1.25163 9.17404 1.51843 10.4191L3.32251 18.8381C3.71771 20.6824 5.34757 22 7.23372 22H16.7664C18.6525 22 20.2824 20.6824 20.6776 18.8381L22.4817 10.4191C22.7485 9.17403 21.7994 8 20.5261 8Z"
                        fill="currentColor"
                      />
                      <g opacity="0.8">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75L12.75 15.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                    <p className="text-base">مدیریت درخواست ها</p>
                  </div>
                </div>
              </div>
            )}
            <button
              className={`${
                location.pathname.includes('/settings')
                  ? 'text-primary border-primary'
                  : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
              } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
            >
              {RealEstateId ? (
                <Link
                  onClick={() => setOpen(false)}
                  to={`/settings`}
                  className="flex flex-row items-center p-4 gap-2 w-full"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.24"
                      d="M12.9545 3H11.0455C9.99109 3 9.13635 3.80589 9.13635 4.8C9.13635 5.93761 7.91917 6.66087 6.92 6.11697L6.81852 6.06172C5.90541 5.56467 4.73782 5.85964 4.21064 6.72057L3.25609 8.27942C2.72891 9.14034 3.04176 10.2412 3.95487 10.7383C4.95451 11.2824 4.95451 12.7176 3.95487 13.2617C3.04176 13.7588 2.72891 14.8597 3.25609 15.7206L4.21064 17.2794C4.73782 18.1404 5.90541 18.4353 6.81851 17.9383L6.92 17.883C7.91917 17.3391 9.13635 18.0624 9.13635 19.2C9.13635 20.1941 9.99109 21 11.0455 21H12.9545C14.0089 21 14.8636 20.1941 14.8636 19.2C14.8636 18.0624 16.0808 17.3391 17.08 17.883L17.1815 17.9383C18.0946 18.4353 19.2622 18.1403 19.7894 17.2794L20.7439 15.7206C21.2711 14.8596 20.9582 13.7588 20.0451 13.2617C19.0455 12.7176 19.0455 11.2824 20.0451 10.7383C20.9582 10.2412 21.2711 9.14036 20.7439 8.27943L19.7894 6.72058C19.2622 5.85966 18.0946 5.56468 17.1815 6.06174L17.08 6.11698C16.0808 6.66088 14.8636 5.93762 14.8636 4.8C14.8636 3.80589 14.0089 3 12.9545 3Z"
                      fill="currentColor"
                    />
                    <circle opacity="0.8" cx="12" cy="12" r="3" fill="currentColor" />
                  </svg>
                  <p className="text-base">تنظیمات</p>
                </Link>
              ) : (
                <button disabled={true} className="disabled:opacity-50 flex flex-row items-center p-4 gap-2 w-full">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.24"
                      d="M12.9545 3H11.0455C9.99109 3 9.13635 3.80589 9.13635 4.8C9.13635 5.93761 7.91917 6.66087 6.92 6.11697L6.81852 6.06172C5.90541 5.56467 4.73782 5.85964 4.21064 6.72057L3.25609 8.27942C2.72891 9.14034 3.04176 10.2412 3.95487 10.7383C4.95451 11.2824 4.95451 12.7176 3.95487 13.2617C3.04176 13.7588 2.72891 14.8597 3.25609 15.7206L4.21064 17.2794C4.73782 18.1404 5.90541 18.4353 6.81851 17.9383L6.92 17.883C7.91917 17.3391 9.13635 18.0624 9.13635 19.2C9.13635 20.1941 9.99109 21 11.0455 21H12.9545C14.0089 21 14.8636 20.1941 14.8636 19.2C14.8636 18.0624 16.0808 17.3391 17.08 17.883L17.1815 17.9383C18.0946 18.4353 19.2622 18.1403 19.7894 17.2794L20.7439 15.7206C21.2711 14.8596 20.9582 13.7588 20.0451 13.2617C19.0455 12.7176 19.0455 11.2824 20.0451 10.7383C20.9582 10.2412 21.2711 9.14036 20.7439 8.27943L19.7894 6.72058C19.2622 5.85966 18.0946 5.56468 17.1815 6.06174L17.08 6.11698C16.0808 6.66088 14.8636 5.93762 14.8636 4.8C14.8636 3.80589 14.0089 3 12.9545 3Z"
                      fill="currentColor"
                    />
                    <circle opacity="0.8" cx="12" cy="12" r="3" fill="currentColor" />
                  </svg>
                  <p className="text-base">تنظیمات</p>
                </button>
              )}
            </button>
            {/* <button
              className={`${
                location.pathname.includes("/help")
                  ? "text-primary border-primary"
                  : "text-text-normal border-light-grey"
              } flex flex-col rounded-md bg-white border-[1px] shadow-sm`}
            >
              <Link onClick={() => setOpen(false)} to={`/help`} className="flex flex-row items-center p-4 gap-2 w-full">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    opacity="0.24"
                    d="M18.3801 12.84V17.77C18.3801 19.04 17.3901 20.4 16.2001 20.8L13.0101 21.86C12.4501 22.05 11.5401 22.05 10.9901 21.86L7.80012 20.8C6.60012 20.4 5.62012 19.04 5.62012 17.77L5.63012 12.84L10.0501 15.72C11.1301 16.43 12.9101 16.43 13.9901 15.72L18.3801 12.84Z"
                    fill="currentColor"
                  />
                  <path
                    opacity="0.8"
                    d="M19.9795 6.46L13.9895 2.53C12.9095 1.82 11.1295 1.82 10.0495 2.53L4.02953 6.46C2.09953 7.71 2.09953 10.54 4.02953 11.8L5.62953 12.84L10.0495 15.72C11.1295 16.43 12.9095 16.43 13.9895 15.72L18.3795 12.84L19.7495 11.94V15C19.7495 15.41 20.0895 15.75 20.4995 15.75C20.9095 15.75 21.2495 15.41 21.2495 15V10.08C21.6495 8.79 21.2395 7.29 19.9795 6.46Z"
                    fill="currentColor"
                  />
                </svg>
                <p className="text-base">راهنما</p>
              </Link>
            </button> */}
            <div
              className={`${
                location.pathname.includes('/market-status')
                  ? 'text-primary border-primary'
                  : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
              } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
            >
              <div className="flex flex-row items-center p-4 relative">
                <Link
                  onClick={() => setOpen(false)}
                  to={`/market-status`}
                  className="absolute w-full h-full right-0 top-0 rounded-md"
                />
                <div className="flex flex-row items-center gap-2 w-full">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="16" width="2" height="5" rx="1" fill="currentColor" opacity="0.7" />
                    <rect x="7" y="12" width="2" height="9" rx="1" fill="currentColor" opacity="0.7" />
                    <rect x="11" y="8" width="2" height="13" rx="1" fill="currentColor" opacity="0.7" />
                    <rect x="15" y="4" width="2" height="17" rx="1" fill="currentColor" opacity="0.7" />
                    <rect x="19" y="10" width="2" height="11" rx="1" fill="currentColor" opacity="0.7" />
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.5" />
                    <path
                      d="M4 18L8 14L12 10L16 6L20 10"
                      stroke="#2563eb"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p className="text-base">وضعیت بازار</p>
                </div>
              </div>
            </div>
            {UserType == 'RealEstate' && (
              <div
                className={`${
                  location.pathname.includes('/qr-code')
                    ? 'text-primary border-primary'
                    : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
                } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
              >
                <div className="flex flex-row items-center p-4 relative">
                  <Link
                    onClick={() => setOpen(false)}
                    to={`/qr-code`}
                    className="absolute w-full h-full right-0 top-0 rounded-md"
                  />
                  <div className="flex flex-row items-center gap-2 w-full">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        opacity="0.24"
                        d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
                        fill="currentColor"
                      />
                      <g opacity="0.8">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6 6H10V10H6V6ZM7 7H9V9H7V7Z"
                          fill="currentColor"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M14 6H18V10H14V6ZM15 7H17V9H15V7Z"
                          fill="currentColor"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6 14H10V18H6V14ZM7 15H9V17H7V15Z"
                          fill="currentColor"
                        />
                        <path d="M11 6H13V8H11V6Z" fill="currentColor" />
                        <path d="M6 11H8V13H6V11Z" fill="currentColor" />
                        <path d="M11 11H13V13H11V11Z" fill="currentColor" />
                        <path d="M15 11H17V13H15V11Z" fill="currentColor" />
                        <path d="M11 14H13V16H11V14Z" fill="currentColor" />
                        <path d="M9 16H15V18H9V16Z" fill="currentColor" />
                        <path d="M15 15H16V16H15V15Z" fill="currentColor" />
                        <path d="M17 15H18V16H17V15Z" fill="currentColor" />
                        <path d="M17 17H18V18H17V17Z" fill="currentColor" />
                      </g>
                    </svg>
                    <p className="text-base">کیو آر کد ساز</p>
                  </div>
                </div>
              </div>
            )}
            <div
              className={`${
                location.pathname.includes('/agent-qr-code')
                  ? 'text-primary border-primary'
                  : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
              } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
            >
              <div className="flex flex-row items-center p-4 relative">
                <Link
                  onClick={() => setOpen(false)}
                  to={`/agent-qr-code`}
                  className="absolute w-full h-full right-0 top-0 rounded-md"
                />
                <div className="flex flex-row items-center gap-2 w-full">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      opacity="0.24"
                      d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.8"
                      d="M12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.8"
                      d="M7 18C7 15.2386 9.23858 13 12 13C14.7614 13 17 15.2386 17 18H7Z"
                      fill="currentColor"
                    />
                    <path
                      d="M18 8.5C18 8.22386 17.7761 8 17.5 8C17.2239 8 17 8.22386 17 8.5V9.5C17 9.77614 17.2239 10 17.5 10C17.7761 10 18 9.77614 18 9.5V8.5Z"
                      fill="currentColor"
                    />
                    <path
                      d="M18 14.5C18 14.2239 17.7761 14 17.5 14C17.2239 14 17 14.2239 17 14.5V15.5C17 15.7761 17.2239 16 17.5 16C17.7761 16 18 15.7761 18 15.5V14.5Z"
                      fill="currentColor"
                    />
                  </svg>
                  <p className="text-base">کارت دیجیتال مشاور</p>
                </div>
              </div>
            </div>
            <div
              className={`${
                location.pathname.includes('/visit-requests')
                  ? 'text-primary border-primary'
                  : 'text-text-normal dark:text-white border-light-grey dark:border-blackFont-700'
              } flex flex-col rounded-md bg-white dark:bg-blackFont-800 border-[1px] shadow-sm`}
            >
              <div className="flex flex-row items-center p-4 relative">
                <Link
                  onClick={() => setOpen(false)}
                  to={`/visit-requests`}
                  className="absolute w-full h-full right-0 top-0 rounded-md"
                />
                <div className="flex flex-row items-center gap-2 w-full">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 12V18"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      opacity="0.8"
                      d="M20 8V7C20 5.34315 18.6569 4 17 4H14.1975C13.5294 4 12.8805 3.77702 12.3535 3.3664L11.4131 2.6336C10.8862 2.22298 10.2372 2 9.56917 2H7C5.34315 2 4 3.34315 4 5V8H20Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.24"
                      d="M20.5261 8H3.47403C2.20074 8 1.25163 9.17404 1.51843 10.4191L3.32251 18.8381C3.71771 20.6824 5.34757 22 7.23372 22H16.7664C18.6525 22 20.2824 20.6824 20.6776 18.8381L22.4817 10.4191C22.7485 9.17403 21.7994 8 20.5261 8Z"
                      fill="currentColor"
                    />
                    <g opacity="0.8">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75L12.75 15.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15.75H9C8.58579 15.75 8.25 15.4142 8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H11.25V12C11.25 11.5858 11.5858 11.25 12 11.25Z"
                        fill="currentColor"
                      />
                    </g>
                  </svg>
                  <p className="text-base">درخواست های بازدید</p>
                </div>
              </div>
            </div>

            <button
              disabled={RealEstateId ? false : true}
              className={` disabled:opacity-50 flex flex-col rounded-md text-text-normal dark:text-white border-light-grey dark:border-blackFont-700 border-[1px] shadow-sm`}
            >
              <div onClick={navigateSubdomain} className="flex flex-row items-center p-4 gap-2 w-full">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5 16.9498H6.71C3.34 16.9498 2.5 16.1098 2.5 12.7398V6.73979C2.5 3.36979 3.34 2.52979 6.71 2.52979H17.24C20.61 2.52979 21.45 3.36979 21.45 6.73979"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.5 21.4702V16.9502"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2.5 12.9502H10.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.24023 21.4702H10.5002"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22.5003 12.7998V18.5098C22.5003 20.8798 21.9103 21.4698 19.5403 21.4698H15.9903C13.6203 21.4698 13.0303 20.8798 13.0303 18.5098V12.7998C13.0303 10.4298 13.6203 9.83984 15.9903 9.83984H19.5403C21.9103 9.83984 22.5003 10.4298 22.5003 12.7998Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.7441 18.25H17.7531"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>نمایش سایت من</p>
              </div>
            </button>
            {isEskanSubdomain && (
              <button
                type="button"
                onClick={() => window.open('https://pro.dubz.ir', '_blank', 'noopener,noreferrer')}
                className="flex flex-row items-center justify-between rounded-2xl bg-gradient-to-r from-[#00C29A] via-[#00A1E0] to-[#0060E6] text-white shadow-[0_14px_30px_rgba(0,96,230,0.25)] px-5 py-4 gap-3"
              >
                <span className="flex items-center justify-center rounded-xl bg-white/15 p-2">
                  <svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4 9.5C4 7.567 5.567 6 7.5 6H12L14 8H20.5C21.8807 8 23 9.11929 23 10.5V19.5C23 21.433 21.433 23 19.5 23H7.5C5.567 23 4 21.433 4 19.5V9.5Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 12.5H21M21 12.5L18.75 10.25M21 12.5L18.75 14.75"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <div className="flex flex-col items-end flex-1">
                  <p className="text-sm font-semibold">ورود به فایلینگ پرو</p>
                  <span className="text-xs text-white/80">دسترسی ویژه املاک های وی آی پی</span>
                </div>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="text-white/90"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 6L15 12L9 18"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            )}
            {/* <button className={`text-error flex flex-col rounded-md border-error bg-[#F9E5E9] border-[1px] shadow-sm`}>
              <div
                onClick={(e) => {
                  setOpenModal(true);
                }}
                className="flex flex-row items-center p-4 gap-2 w-full"
              >
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M17.6172 8.81979C17.2555 4.61979 15.0972 2.90479 10.3722 2.90479H10.2205C5.00552 2.90479 2.91719 4.99312 2.91719 10.2081V17.8148C2.91719 23.0298 5.00552 25.1181 10.2205 25.1181H10.3722C15.0622 25.1181 17.2205 23.4265 17.6055 19.2965"
                    stroke="#E11640"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.5007 14H23.7773"
                    stroke="#E11640"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21.1757 10.0918L25.084 14.0001L21.1757 17.9085"
                    stroke="#E11640"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="text-base">خروج از داشبورد</p>
              </div>
            </button> */}
          </div>
        </div>
      </div>
      {openModal && (
        <ConfirmationModal
          setShowModal={setOpenModal}
          handler={() => logoutHandler()}
          title="خروج از حساب کاربری"
          desc="آیا از خروج از حساب کاربری خود اطمینان دارید؟"
          btnText="تأیید خروج"
        />
      )}
    </>
  );
}
